module.exports = __webpack_public_path__ + "ptc_momoro_J2.599574f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_J2.jpg
// module id = ZbzA
// module chunks = 0